module.exports = __webpack_public_path__ + "media/images/number_18-c44345a7b859dd10fa5966cfdc3ee7e4.png";